var tag1 = "";
var tag2 = "Axiome 10mm Clear Roof Calc";
var tag3 = "Alukap-SS Lean To Canopy";
var rooftype = "Axiome";
var rfnm = 1;
var collection1 = 0;
var collection2 = 0;
var lntha = 0;
var lnthb = 0;
var lnthc = 0;
var maxlen = 0;
var double = 1;
var quantity = 1;
var sheets = 1;
var clrcart = 0;
var products = [];
var products1 = [];
var products2 = [];
var colours1 = [];
var colours2 = [];
var colour1 = 'Clear';
var colour2 = '';
var thickness = '';
var mycart = [];
var newcart = [];
var mcaheaders = {method: 'get', headers: new Headers({'Authorization': 'Token 56e79298c2a7bf646d367522b3e2350ee6841de1','Content-Type': 'application/x-www-form-urlencoded'})};
var apiurl = 'https://myclearamber.com/mycapi/v1/cashop/';
if("cas.grokurv.co.uk" == window.location.hostname){
  var apiurl = 'https://myclearamber.com/mycapi/v1/cashopDev/';
}
$(".roofcal .roofimg").click(function(){
  	tag1 = $(this).attr('title');
  	rfnm = $(this).attr('key');
    var image = $(this).find('img').attr('src');
    var img = tag1.replaceAll('– ','');
    img = img.replaceAll(' ','_')+"_"+rfnm;
    image = image.replace(img,"Axiome_"+img+"_"+colour1);
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
  	$('.roofsheet img').attr('src',image);
  	$('.roofsheet img').attr('key',$(this).find('img').attr('src'));
  	$('.roofsize img').attr('src',image);
  	$('.roofsize img').attr('key',$(this).find('img').attr('src'));
  	apicall();
    $('select[name="colour1"]').val('Clear').trigger('change');
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
    $('select[name="thickness"]').val('');
    $('select[name="colour2"]').val('');
});

$(".roofcal .yrc").click(function(){
  	if(tag1 == ''){
    	return false;
    }
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
})

function collection11(){
  	var colfltr = tag1+" || "+tag2;
  	var tags =fetch(apiurl+"products/?ctag="+colfltr, mcaheaders)
      .then(response => response.json())
      .then(data => {
        				collection1 = data['results'][0];
        				products1 = data['results'];
        				cproducts(data['results'], 1);
        				return data 
                    });
}

function collection22(){
	var colfltr = tag1+" || "+tag3;
  	var tags = fetch(apiurl+"products/?ctag="+colfltr, mcaheaders)
      .then(response => response.json())
      .then(data => {
        				collection2 = data['results'][0];
        				products2 = data['results'];
        				cproducts(products2, 2);
        				return data 
                    });
}

$('select[name="thickness"]').change(function(){
    thickness = $(this).val();
    tag2 = 'Axiome '+thickness+' '+colour1+' Roof Calc';
    apicall();
})

$('select[name="colour1"]').change(function(){
  	clearCart();
  	newcart = [];
  	colour1 = $(this).val();
  	// $('.roofselect button').attr('disabled',false);
	$('.products .tag1 select[name="COLOUR"]').val(colour1);
  	$('.products .tag1 select[name="COLOUR"]').attr('disabled','disabled');
    tag2 = 'Axiome '+thickness+' '+colour1+' Roof Calc';
    apicall();
})

$('select[name="colour2"]').change(function(){
  	colour2 = $(this).val();
	$('.products .tag2 select[name="COLOUR"]').val(colour2);
  	$('.products .tag2 select[name="COLOUR"]').attr('disabled','disabled');

    var ims = $('.roofsheet img').attr('key');
    $(".roofsheet img, .roofsize img").attr("src",ims.replace('.jpg','-'+colour2+'.jpg').replace(' ','-'));
    apicall();
})

function apicall(){
  if(colour1 != '' && colour2 != '' && thickness != ''){
    $(".rfsize").attr('disabled',false);
    collection11();
    collection22();
  }
}

$('.rfsize').click(function(){
    if(colour1 == ''){
      alert("Please select Colours First?");
      return false;
    }
  	$('.rooftype').hide();
  	$('.roofsheet').hide();
  	$('.roofsize').show();
//   	$('.products').show();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor, .roofcal .number.yrc").addClass("complete");
  	$(".roofcal .number.cyrs").addClass("current");
    $('.roofinput input[name="lengtha"]').val(0);
    $('.roofinput input[name="lengthb"]').val(0);
    $('.roofinput input[name="lengthc"]').val(0);
    $('.ckit').attr("disabled",false);
})

$('.srtype').click(function(){
	$('.rooftype').show();
  	$('.roofsheet').hide();
  	$('.roofsize').hide();
  	$('.products').html('').hide();
//   	$('input, select').val('');
  	$('.colour1, .colour2').hide();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("current");
    $('.rfsize').attr("disabled",false);
})


function cproducts(pdata, tg){
	products = products.concat(pdata);
    if(tg == 1){
      for(let i = 0; i < products1[0]['options'].length; i++){
        if(products1[0]['options'][i]['name']=='COLOUR'){
          colours1 = products1[0]['options'][i]['values'];
        }
      }
    }
    if(tg == 2){
      for(let i = 0; i < products2[0]['options'].length; i++){
        if(products2[0]['options'][i]['name']=='COLOUR'){
          colours2 = products2[0]['options'][i]['values'];
        }
      }
    }
}


$('.ckit').click(function(){
  	$(this).attr("disabled","disabled");
  	clearCart();
    // maxlen = parseInt(products1[0]['options'][1]['values'].at(-1).replace('mm',''));
    maxlen = 6000;
  	lntha = parseInt($('.roofinput input[name="lengtha"]').val());
  	lnthb = parseInt($('.roofinput input[name="lengthb"]').val());
  	if(lntha < 99 || lnthb < 99){
    	alert("Please enter the valid length and width");
        $(this).attr("disabled",false);
      	return false;
    }
    if(lnthb > maxlen){
      alert("This size is too long, please get free advice on Live Chat");
      $(this).attr("disabled",false);
      return false;
    }
  	for(let i = 0; i < products.length; i++){
    	if(products[i]['options'].length == 1){
          quantitycal(products[i], i);
        }
    }
  	lengthCal(products2);
  	updateCart();
})


function quantitycal(prdt, index){
  var lengthq = 1;
  var widthq = 1;
  if(lntha > 950){
//     lntha -= 100;
    lengthq = parseInt((lntha-100)/850)+1;
  }
  if(lnthb > 2000){
//     lnthb -= 150;
    widthq = parseInt((lnthb-150)/1850)+1;
  }
  quantity = lengthq*widthq;
  $('.products .option1 .quantity').val(quantity*double);		// Fill the Quantity
  $('.products .PACK .quantity').val(quantity*double*2);		// Fill the pack quantity
  return quantity*double;
}

function lengthacal(){
	var lengthq = 1;
  	if(lntha > 950){
//       lntha -= 100;
      lengthq = parseInt((lntha-100)/850)+1;
    }
  return lengthq;
}
function lengthbcal(newb,ltb){
	var widthq = 1;
  	if(newb > ltb){
//       lnthb -= 150;
      widthq = parseInt((newb-150)/(ltb-150))+1;
    }
  return widthq;
}


function updateCart(){
  console.log("New Cart Items =", newcart);

  function sortProducts(data) {
    return data.sort((a, b) => {
      const numA = parseInt(a.sno.replace("PRODUCT", ""), 10);
      const numB = parseInt(b.sno.replace("PRODUCT", ""), 10);
      return numA - numB;
    });
  }
  const sortedData = sortProducts(newcart);
    // Add Product to Cart
    var citems = [];
    for(let c=0; c<sortedData.length; c++){
      if (JSON.stringify(citems).indexOf(sortedData[c]['variant']) > 0){
        for (let v = 0; v < citems.length; v++) {
          if (citems[v]['id']==sortedData[c]['variant']){
            citems[v]['quantity'] = citems[v]['quantity']+sortedData[c]['quantity'];
          }else{
            citems[v]['quantity'] = citems[v]['quantity'];
          }
        }
      }else{
        // console.log(newcart[c]);
        citems.push({"quantity":sortedData[c]['quantity'], "id":sortedData[c]['variant'], properties: {"Title":sortedData[c]['title'], "ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":sortedData[c]['sno'] }});
      }
      // citems.push({"quantity":newcart[c]['quantity'], "id":newcart[c]['variant'], properties: {"Title":newcart[c]['title'], "ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":newcart[c]['sno']}});
    }

    citems.reverse();

    myInterval = setInterval(function () {
      if(clrcart == 0){
        jQuery.post('/cart/add.js', {
          items: citems
        }).then(data => {
          $(".ckit").attr("disabled",false);
          // window.location.href = '/cart';
          if(window.location.pathname.indexOf('fr-fr') == 1){ window.location.href = '/fr-fr/cart'; }else{ window.location.href = '/cart'; }
        });
        clearInterval(myInterval);
      }else{
          // console.log(clrcart);
      }
    }, 500);
}

function lengthCal(prod){
  var apex = 1;
  for(let p=0; p<products1.length; p++){
    let noptions = products1[p]['options'][0]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
  	noptions = noptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
    let boptions = products1[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
  	boptions = boptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
    var sheets = Math.ceil(lntha/(noptions[0]+10))*apex;
    var lstvidx = 0;
    var sizeb = boptions[boptions.length-1];
    for (let b = 0; b < boptions.length; b++) {
      if(lnthb <= boptions[b]){
        sizeb = boptions[b];
        break;
      }
    }
    for (let v = 0; v < products1[p]['variants'].length; v++) {
      if(products1[p]['variants'][v]['title'] == noptions[0]+'mm / '+sizeb+'mm'){
        lstvidx = v
      }
    }
    newcart.push({"sno":"PRODUCT1", "quantity":sheets, "product":products1[p]['id'], "title":products1[p]['variants'][lstvidx]['title'], "variant":products1[p]['variants'][lstvidx]['vid'], "sku":products1[p]['variants'][lstvidx]['sku'], "class":"COLOUR", "tag":1});
  }
  
  for(let p = 0; p < products2.length; p++){
    var lthoption = [];
    var ttl = '';
    var tgstr = JSON.stringify(products2[p]['tags']);
    if(tgstr.indexOf('PRODUCT') > 0){ ttl = tgstr.substring(tgstr.indexOf('PRODUCT'), tgstr.indexOf('PRODUCT')+10).replace('"','').replace(' ','') }
    if(ttl == 'PRODUCT2'){
      var qty = 0;
      // let noptions = products2[p]['options'][0]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      // noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      // var idx = noptions.length-1;
      // for (let j = 0; j < noptions.length; j++) {
      //   if(lnthb <= noptions[j]){ idx = j; break; }
      // }
      var idx = 0 ;
      for (let v = 0; v < products2[p]['variants'].length; v++) {
        if (products2[p]['variants'][v]['title'].indexOf(colour2) == 0) {
          idx = v;
        }
      }
      qty = Math.ceil(lntha/2000)+1;
      if (tag1 == 'Lean To With Solid Sides - 2 x Gables' || tag1 == 'Lean To With Solid Sides - 1 x Wall Upstand and 1 x Gable Side' || tag1 =='Lean To With Solid Sides - 2 x Wall Upstand Sides') {
        qty = 0;
      }
      newcart.push({"sno":"PRODUCT2", "quantity":qty, "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
    }
    if(ttl == 'PRODUCT3'){
      var qty = 1;
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions.length-1;
      if (noptions[idx] <= lntha) {
        idx = noptions.length-1;
        for (let v = 0; v < products2[p]['variants'].length; v++) {
          if (products2[p]['variants'][v]['title'] == colour2+' / '+(noptions[idx]/1000).toFixed(1)+'m') {
            newcart.push({"sno":ttl, "quantity":parseInt(lntha/noptions[idx])*2, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
          }
        }
        // newcart.push({"sno":ttl, "quantity":parseInt(lntha/noptions[idx])*2, "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
      }
      for (let j = 0; j < noptions.length; j++) {
        if (lntha%noptions[idx] > 0 && lntha%noptions[idx] <= noptions[j]) {
          idx = j;
          for (let v = 0; v < products2[p]['variants'].length; v++) {
            if (products2[p]['variants'][v]['title'] == colour2+' / '+(noptions[idx]/1000).toFixed(1)+'m') {
              newcart.push({"sno":ttl, "quantity":qty*2, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
            }
          }
          break;
        }
      }
    }
    if(ttl == 'PRODUCT4'){
       qty4 = 1;
      if(tag1 == 'Lean To With Solid Sides - 2 x Gables' || tag1=='Lean To With Open Sides (Front Posts) 2 x Gables'){ qty4 = 2; }
      for (let j = 0; j < products2[p]['variants'].length; j++) {
        if(products2[p]['variants'][j]['title'].indexOf(colour2) >= 0){
          newcart.push({"sno":"PRODUCT4", "quantity":qty4, "product":products2[p]['id'], "title":products2[p]['variants'][j]['title'], "variant":products2[p]['variants'][j]['vid'], "sku":products2[p]['variants'][j]['sku'], "class":"WIDTH", "tag":2});
        }
      }
    }
    if(ttl == 'PRODUCT5'){
      var qty = 1;
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions.length-1;
      if (noptions[idx] <= lntha) {
        idx = noptions.length-1;
        for (let v = 0; v < products2[p]['variants'].length; v++) {
          if (products2[p]['variants'][v]['title'] == colour2+' / '+(noptions[idx]/1000).toFixed(1)+'m') {
            newcart.push({"sno":ttl, "quantity":parseInt(lntha/noptions[idx]), "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
          }
        }
        // newcart.push({"sno":ttl, "quantity":parseInt(lntha/noptions[idx]), "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
      }
      for (let j = 0; j < noptions.length; j++) {
        if (lntha%noptions[idx] > 0 && lntha%noptions[idx] <= noptions[j]) {
          idx = j;
          for (let v = 0; v < products2[p]['variants'].length; v++) {
            if (products2[p]['variants'][v]['title'] == colour2+' / '+(noptions[idx]/1000).toFixed(1)+'m') {
              newcart.push({"sno":ttl, "quantity":qty, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
            }
          }
          break;
        }
      }
    }
    if(ttl == 'PRODUCT6'){
      var qt6 = 1;
      qt6 = parseInt((lntha)/10000);
      if((lntha)%10000 != 0){ qt6 += 1; }
      newcart.push({"sno":"PRODUCT6", "quantity":qt6, "product":products2[p]['id'], "title":products2[p]['variants'][0]['title'], "variant":products2[p]['variants'][0]['vid'], "sku":products2[p]['variants'][0]['sku'], "class":"WIDTH", "tag":2});
    }
    if(ttl == 'PRODUCT7'){
      var qty = 1;
      let noptions = products2[p]['options'][2]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions.length-1;
      if (noptions[idx] < lntha) {
        idx = noptions.length-1;
        for (let v = 0; v < products2[p]['variants'].length; v++) {
          if (products2[p]['variants'][v]['title'] == colour2+' / '+thickness+' / '+parseFloat(noptions[idx]/1000).toFixed(1)+'m') {
             newcart.push({"sno":ttl, "quantity":parseInt(lntha/noptions[idx]), "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});   
          }
        }
      }
      for (let j = 0; j < noptions.length; j++) {
        if (lntha%noptions[idx] <= noptions[j]) {
          idx = j;
          for (let v = 0; v < products2[p]['variants'].length; v++) {
            if (products2[p]['variants'][v]['title'] == colour2+' / '+thickness+' / '+parseFloat(noptions[j]/1000).toFixed(1)+'m') {
               newcart.push({"sno":ttl, "quantity":qty, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});   
            }
          }
          break;
        }
      }
    }
    if(ttl == 'PRODUCT8'){
      if (lnthb > 3000) { continue; }
      var qty = 1;
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions.length-1;
      if (noptions[idx] < lntha) {
        idx = noptions.length-1;
        for (let v = 0; v < products2[p]['variants'].length; v++) {
          // console.log(products2[p]['variants'][v]['title'], colour2+' / '+parseFloat(noptions[idx]/1000).toFixed(1)+'m');
          if (products2[p]['variants'][v]['title'] == colour2+' / '+parseFloat(noptions[idx]/1000).toFixed(1)+'m') {
             newcart.push({"sno":ttl, "quantity":parseInt(lntha/noptions[idx])*2, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});   
          }
        }
      }
      for (let j = 0; j < noptions.length; j++) {
        if (lntha%noptions[idx] <= noptions[j]) {
          idx = j;
          for (let v = 0; v < products2[p]['variants'].length; v++) {
            if (products2[p]['variants'][v]['title'] == colour2+' / '+parseFloat(noptions[j]/1000).toFixed(1)+'m') {
               newcart.push({"sno":ttl, "quantity":qty*2, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});   
            }
          }
          break;
        }
      }
    }
    if(ttl == 'PRODUCT9'){
      if (lnthb < 3001) { continue; }
      var qty = 1;
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions.length-1;
      if (noptions[idx] < lntha) {
        idx = noptions.length-1;
        for (let v = 0; v < products2[p]['variants'].length; v++) {
          // console.log(products2[p]['variants'][v]['title'], colour2+' / '+parseFloat(noptions[idx]/1000).toFixed(1)+'m');
          if (products2[p]['variants'][v]['title'] == colour2+' / '+parseFloat(noptions[idx]/1000).toFixed(1)+'m') {
             newcart.push({"sno":ttl, "quantity":parseInt(lntha/noptions[idx])*2, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});   
          }
        }
      }
      for (let j = 0; j < noptions.length; j++) {
        if (lntha%noptions[idx] <= noptions[j]) {
          idx = j;
          for (let v = 0; v < products2[p]['variants'].length; v++) {
            if (products2[p]['variants'][v]['title'] == colour2+' / '+parseFloat(noptions[j]/1000).toFixed(1)+'m') {
               newcart.push({"sno":ttl, "quantity":qty*2, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});   
            }
          }
          break;
        }
      }
    }
    if(ttl == 'PRODUCT10' || ttl == 'PRODUCT12' || ttl == 'PRODUCT14'){
      var qty = sheets-1;
      if (ttl == 'PRODUCT12' || ttl == 'PRODUCT14'){ qty = 1; }
      if (ttl == 'PRODUCT12' && (tag1 == "Lean To With Solid Sides - 2 x Gables" || tag1 == "Lean To With Open Sides (Front Posts) 2 x Gables")) { qty = 2; }
      if (ttl == 'PRODUCT14' && (tag1 == "Lean To With Solid Sides - 2 x Wall Upstand Sides" || tag1 == "Lean To With Open Sides (Front Posts) - 2 x Wall Upstand Sides") ) { qty = 2; }
      if (lnthb > 3000) { qty = 0; }
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions[0];
      for (let j = 0; j < noptions.length; j++) {
        if (lnthb <= noptions[j]) { idx = noptions[j]; break; }
      }
      for (let j = 0; j < products2[p]['variants'].length; j++) {
          if(products2[p]['variants'][j]['title'] == colour2+" / "+parseFloat(idx/1000).toFixed(1)+"m"){
          newcart.push({"sno":ttl, "quantity":qty, "product":products2[p]['id'], "title":products2[p]['variants'][j]['title'], "variant":products2[p]['variants'][j]['vid'], "sku":products2[p]['variants'][j]['sku'], "class":"WIDTH", "tag":2});
        }
      }
    }
    if(ttl == 'PRODUCT11' || ttl == 'PRODUCT13' || ttl == 'PRODUCT15'){
      var qty = sheets-1;
      if (ttl == 'PRODUCT13' || ttl == 'PRODUCT15'){ qty = 1; }
      if (ttl == 'PRODUCT13' && (tag1 == "Lean To With Solid Sides - 2 x Gables" || tag1 == "Lean To With Open Sides (Front Posts) 2 x Gables")) { qty = 2; }
      if (ttl == 'PRODUCT15' && (tag1 == "Lean To With Solid Sides - 2 x Wall Upstand Sides" || tag1 == "Lean To With Open Sides (Front Posts) - 2 x Wall Upstand Sides") ) { qty = 2; }
      if (lnthb < 3001) { qty = 0; }
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions[0];
      for (let j = 0; j < noptions.length; j++) {
        if (lnthb <= noptions[j]) { idx = noptions[j]; break; }
      }
      for (let j = 0; j < products2[p]['variants'].length; j++) {
          if(products2[p]['variants'][j]['title'] == colour2+" / "+parseFloat(idx/1000).toFixed(1)+"m"){
          newcart.push({"sno":ttl, "quantity":qty, "product":products2[p]['id'], "title":products2[p]['variants'][j]['title'], "variant":products2[p]['variants'][j]['vid'], "sku":products2[p]['variants'][j]['sku'], "class":"WIDTH", "tag":2});
        }
      }
    }
    
    $('.products .'+products2[p]["id"]+' .total').html("");
    for(let v = 0; v < products2[p]['variants'].length; v++){
      for(let l = 0; l < lthoption.length; l++){
        if(lthoption.length > 0 && products2[p]['variants'][v]['title'] == colour2+' / '+lthoption[l]['length']){
          	$('.products .prod'+products2[p]["id"]+' .total').append("<p>SKU : <strong>"+products2[p]['variants'][v]['sku']+"</strong> Variant : "+products2[p]['variants'][v]['title']+' qty : '+lthoption[l]['quantity']+'</p>');
            newcart.push({"sno":ttl, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "quantity":lthoption[l]['quantity'], "class":"LENGTH "+ttl, "tag":2});
        }
      }
    }
  }
}

function clearCart(){
  	clrcart = 1;
  	newcart = [];
	$.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
//             Shopify.clear();
          clrcart = 0;
        },
        error: function(XMLHttpRequest, textStatus) {
          clrcart = 0;
          console.log("Clear Cart Error");
          /* error code */
        }
      });
}